import { useState } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import CourseCard from "./CourseCard";
import "./CourseExplorer.css";

const CourseExplorer = ({ title, highlightText, courses }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredCourses = courses.filter((course) =>
    course.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="course-explorer">
      <h1 className="course-explorer__title">
        {title.replace(highlightText, "")}
        <span className="course-explorer__highlight">{highlightText}</span>
      </h1>

      <div className="course-explorer__search">
        <input
          type="text"
          placeholder="Explore Courses by age"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="course-explorer__search-input"
        />
        <button className="course-explorer__search-button">Search</button>
      </div>

      <div className="course-explorer__grid">
        {filteredCourses.map((course, index) => (
          <Link to={course.path} key={index} className="course-explorer__link">
            <CourseCard
              image={course.image}
              // icon={course.icon}
              title={course.title}
              // iconBgColor={course.iconBgColor}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CourseExplorer;
